import React from 'react';
import {useHistory} from 'react-router-dom';
import TermsForm from './terms-form/TermsForm';

import {
    COMPLEMENT_MODULES,
    HistoryRoutes,
    INITIAL_MODULES,
    MODULES,
    Roles,
} from 'commons/constants';
import {useMenuContext} from 'context/onboarding-menu/OnboardingMenu';
import {
    ClientContactServiceRequest,
    EfeResponse,
    Layout,
    RegisterServiceValues,
} from 'commons/models';
import {ClientService, LayoutServices} from 'services';
import {useSpinner} from 'hooks';
import {useUserContext} from 'context/user/UserContext';
import {modulesValidation} from 'commons/utils/Functions';

function TermsAndConditions() {
    const history = useHistory();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const {
        updateMenu,
        setExpedientId,
        setFatherKycId,
        setPersonType,
        updateLayout,
        setKycId,
        setForeign,
    } = useMenuContext();
    const {user} = useUserContext();

    async function getLayoutData(params: RegisterServiceValues) {
        const layoutResponse: EfeResponse<Layout> = await LayoutServices.getLayoutByPersonType(
            params
        );
        if (
            layoutResponse &&
            layoutResponse.data &&
            layoutResponse.data.views &&
            layoutResponse.data.views.length
        ) {
            updateLayout(layoutResponse.data);
            updateMenu([
                ...modulesValidation([...MODULES], layoutResponse.data),
                ...COMPLEMENT_MODULES,
            ]);
        } else {
            updateMenu([...INITIAL_MODULES]);
        }
    }

    const submitHandler = async () => {
        setIsLoading(true);
        try {
            const response: EfeResponse<ClientContactServiceRequest> =
                await ClientService.getClientContact(user.username);
            if (response && response.data) {
                setExpedientId(response.data.expedientId);
                setFatherKycId(response.data.kycId ? response.data.kycId : 0);
                setPersonType(response.data.personTypeKey);
                setForeign(!!response.data.foreign);
                setKycId(-1);
                const params: RegisterServiceValues = {
                    personType: response.data.personTypeKey,
                    foreign: response.data.foreign,
                    rol: Roles.CLIENT,
                    isMigrated: user.isMigrated,
                };
                await getLayoutData(params);
            }
            setIsLoading(false);
        } catch (error) {
            updateMenu([...INITIAL_MODULES, ...COMPLEMENT_MODULES, ...MODULES]);
            setIsLoading(false);
        }
        if (user.isMigrated) {
            history.push(HistoryRoutes.PRE_SIGN_TERMS);
        } else {
            history.push(HistoryRoutes.REGISTER);
        }
    };

    const handleReturn = () => {
        history.push(HistoryRoutes.BEFORE_START);
    };

    /* eslint-disable react/jsx-handler-names */
    return (
        <div className='TermsAndConditions'>
            {isLoading && useSpinner(isLoading)}
            <TermsForm submitHandler={submitHandler} handleReturn={handleReturn} />
        </div>
    );
}

export default TermsAndConditions;
